import { Component } from '@angular/core';

@Component({
  templateUrl: 'repoagency.component.html'
})
export class RepoagencyComponent {

  constructor() { 

  } 
}


// WEBPACK FOOTER //
// ./src/app/agencies/repoagency.component.ts